import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { BD, Card, StatusBadge } from '../styles'

const Caixa = styled(Card)`
  padding: 14px;
`

const Topo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Numero = styled.span`
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  color: ${BD.grayText};
`

const Quando = styled.span`
  margin-left: auto;
  font-size: 12px;
  color: ${BD.grayText};
`

const Titulo = styled.div`
  margin-top: 6px;
  font-size: 15px;
  font-weight: 600;
`

const Movimento = styled.div`
  margin-top: 2px;
  font-size: 13px;
  color: ${BD.grayText};
`

const Rodape = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid ${BD.grayBorder};
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${BD.grayText};
`

export interface CartaoLinhaProps {
  numero?: ReactNode
  tipo?: { bg: string; color: string; label: string }
  quando: ReactNode
  titulo: ReactNode
  movimento?: ReactNode
  referencia?: ReactNode
  nota?: ReactNode
  acao?: ReactNode
}

/**
 * OP-3619 — a linha densa do razão e dos históricos, em cartão.
 *
 * Seis colunas que só fazem sentido lado a lado viram quatro blocos que fazem
 * sentido em coluna: o que foi (tipo e número), sobre o quê (item e peça),
 * para onde (origem → destino) e por quê (referência e autor). A ação, quando
 * existe, fica no rodapé — nunca antes de a pessoa ter lido o que vai mexer.
 */
export const CartaoLinha: FC<CartaoLinhaProps> = ({ numero, tipo, quando, titulo, movimento, referencia, nota, acao }) => (
  <Caixa>
    <Topo>
      {numero && <Numero>{numero}</Numero>}
      {tipo && <StatusBadge $bg={tipo.bg} $color={tipo.color}>{tipo.label}</StatusBadge>}
      <Quando>{quando}</Quando>
    </Topo>
    <Titulo>{titulo}</Titulo>
    {movimento && <Movimento>{movimento}</Movimento>}
    {(referencia || nota || acao) && (
      <Rodape>
        <span style={{ flexGrow: 1, minWidth: 0 }}>
          {referencia}
          {referencia && nota ? ' · ' : ''}
          {nota}
        </span>
        {acao}
      </Rodape>
    )}
  </Caixa>
)

export default CartaoLinha
